import 'css-chunksrc/client/scenes/workloads/wbs/project/dateForm/styles.scss';export default {
  "dateForm": "_dateForm_ptpfk_1",
  "input": "_input_ptpfk_5",
  "readOnly": "_readOnly_ptpfk_12",
  "disabled": "_disabled_ptpfk_18"
};